import { useEffect, useState } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import CustomToggle from '../../../components/CustomToggle';
import HotelController, {
  CheckoutRoomListType,
  LateCheckoutByExtendType,
} from '../../../controller/HotelController';
import { CurrentStoreContext } from '../../../controller/StoreController';
import HotelCheckoutSetting from './HotelCheckOutSetting';

const HotelCheckOut = () => {
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [noticeType, setNoticeType] = useState<boolean>(false);
  const [checkoutType, setCheckoutType] = useState<number>(0);
  const [roomList, setRoomList] = useState<CheckoutRoomListType[]>([]);
  const [saveMomo, setSaveMomo] = useState<string[]>([]);

  const nextPageButton = (type: number) => {
    setNoticeType(true);
    setCheckoutType(type);
  };
  const roomTypeData = (type: number) => {
    if (type === 0) {
      return '퇴실';
    } else if (type === 1) {
      return '대실';
    } else if (type === 2) {
      return '숙박';
    }
  };

  // 연장 가능 토글 설정
  const getLatecheckoutFlag = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
      };
      const oRes: any = await HotelController.getLatecheckoutFlag(oParams);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data.data;
        setRoomList(oResponse);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const setLateCheckoutFlag = async (gadeId: number, checkOut: boolean, type: number) => {
    try {
      const oParams = {
        store_id: currentStore.value,
        area_grade_id: gadeId,
        late_checkout: !checkOut,
        extend_type: type,
      };
      const oRes: any = await HotelController.setLateCheckoutFlag(oParams);

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data.data;
        getLatecheckoutFlag();
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 퇴실 시 사용했던 메모
  const getLatestCheckoutSentence = async () => {
    try {
      const oParams: any = {
        store_id: currentStore.value,
        notice_type: checkoutType,
      };
      const oRes: any = await HotelController.getLatestCheckoutSentence(oParams);

      if (oRes && oRes.data) {
        setSaveMomo(oRes.data.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    nextPageButton(0);
  }, []);
  useEffect(() => {
    if (checkoutType !== undefined) {
      getLatestCheckoutSentence();
      if (checkoutType === 0) {
        getLatecheckoutFlag();
      }
    }
  }, [checkoutType]);

  return (
    <Style>
      <>
        <div className="contentContainer">
          <div className="title main">
            <h2>연장 가능 설정</h2>
            <div>
              <Link to={'/setting/roomType'} className="movePage">
                객실 그레이드 지정
              </Link>
              <Link to={'/room/roomSale'} className="movePage">
                퇴실연장 상품 설정
              </Link>
            </div>
          </div>
          {checkoutType === 0 && (
            <div className="box">
              <div className="boxRow title">
                <p>객실타입 시간연장 설정</p>
              </div>
              <div className="boxRow">
                {roomList?.length > 0 ? (
                  <>
                    {roomList.map((data: CheckoutRoomListType, index: number) => (
                      <div className="roomList" key={index}>
                        <p>{data.area_grade_name}</p>
                        <div className="toggleGroup">
                          {data.lateCheckoutByExtendType.map(
                            (item: LateCheckoutByExtendType, idx) => (
                              <div key={idx} className="toggleItem">
                                <p>{roomTypeData(item.extend_type)}</p>
                                <CustomToggle
                                  toggleItem={item.late_checkout}
                                  onChange={() =>
                                    setLateCheckoutFlag(
                                      data.area_grade_id,
                                      item.late_checkout,
                                      item.extend_type,
                                    )
                                  }
                                  activeColor="#4dd2ae"
                                />
                              </div>
                            ),
                          )}
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <div className="noneList">
                    <h2>등록된 객실이 없습니다.</h2>
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="noticeTypeWrap">
            <div className="guideWrapper">
              <h2 className="title guide">발송 설정</h2>
            </div>
            <div className="boxWrap">
              {[0, 1, 2].map((index) => (
                <button
                  key={index}
                  onClick={() => nextPageButton(index)}
                  className={`box type ${checkoutType === index ? 'selected' : ''}`}>
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_notice_type${index + 1}.svg`}
                    alt={`알림 아이콘 ${index + 1}`}
                  />
                  <div>
                    <h2>
                      {index === 0 ? '일괄 알림' : index === 1 ? '호실 지정 알림' : '즉시 알림'}
                    </h2>
                    <p>
                      {index === 0
                        ? '매일 알림 설정'
                        : index === 1
                        ? '객실별 시간 지정하여 알림\n(일괄알림에서 제외됨)'
                        : '즉시 지정객실 알림'}
                    </p>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </>
      {noticeType && (
        <HotelCheckoutSetting
          checkoutType={checkoutType}
          saveMomo={saveMomo}
          getLatestCheckoutSentence={getLatestCheckoutSentence}
        />
      )}
    </Style>
  );
};

export default HotelCheckOut;

const Style = styled.div`
  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #555;
  }
  p {
    font-size: 14px;
    font-weight: 500;
    color: #555;
    white-space: normal;
  }

  /* title */
  .title {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title.guide {
    justify-content: flex-start;
    gap: 10px;
  }
  .guideWrapper {
    position: relative;
  }
  .guideWrapper:hover .guideBox {
    display: block;
  }
  .questionIcon {
    cursor: pointer;
  }
  .guideBox {
    display: none;
    position: absolute;
    padding: 10px 20px 14px 20px;
    top: 30px;
    left: 12%;
    background: #edeeee;
    border-radius: 5px;
    box-shadow: 3px 3px 7px 0px #0000001a;

    h3 {
      margin-bottom: 6px;
      font-size: 14px;
      font-weight: 500;
      color: #979797;
    }
    p {
      font-size: 12px;
      font-weight: 500;
      line-height: 20px;
      color: #979797;
    }
  }
  .movePage {
    margin-left: 12px;
    padding: 6px 10px;
    border: 1px solid #4dd2ae;
    font-size: 14px;
    font-weight: 500;
    color: #4dd2ae;
    border-radius: 6px;
  }

  /* noticeTypeWrap */
  .noticeTypeWrap {
    margin-top: 65px;
  }

  /* box */
  .box {
    border: 1px solid #cecece;
    border-radius: 6px;
  }
  .box.type {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    img {
      margin: 0;
      padding: 0 10px;
    }
    p {
      margin-top: 3px;
      font-size: 12px;
      font-weight: 500;
      color: #979797;
      line-height: 16px;
    }
  }
  .box.type.selected {
    background: #f7f7f7;
    border: 4px solid #4dd2ae;
  }
  .boxRow {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    gap: 0 50px;
    padding: 12px 37px;
  }

  .roomList {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    gap: 8px;
  }
  .toggleGroup {
    width: 60%;
    display: flex;
    justify-content: space-between;

    .toggleItem {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
  .boxRow:nth-child(1) {
    margin-bottom: 0;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    background: #ecf5f3;
  }

  /* boxWrap */
  .boxWrap {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 2%;
    cursor: pointer;

    .box {
      flex: 1;
      padding: 25px 4px;
      text-align: center;
    }
    .box.selected {
      padding: 22px 1px;
    }
  }

  .noneList {
    flex: 1;
    padding: 20px 0;

    h2 {
      color: #cecece;
      font-weight: 400;
      text-align: center;
    }
  }

  /* submitButton */
  .submitButton {
    margin-top: 100px;
  }

  @media (max-width: 900px) {
    .contentContainer {
      width: 100% !important;
    }
    p {
      font-size: 12px;
    }
    .box.type {
      gap: 10px;

      h2 {
        font-size: 14px;
      }
    }
    .boxRow {
      padding: 12px 16px;
    }
    .roomList {
      flex-direction: column;
      align-items: flex-start;
      margin: 10px 0;
    }
    .toggleGroup {
      gap: 20px;
      .toggleItem {
        gap: 6px;
      }
    }
  }
  @media (max-width: 500px) {
    .title.main {
      flex-wrap: wrap;
      h2 {
        margin-bottom: 20px;
      }
      a {
        margin-left: 0;
        margin-right: 10px;
      }
    }
    .box.type {
      flex-direction: column;
      p {
        font-size: 10px;
        line-height: 14px;
      }
    }
  }
`;
